import { FloatingWindow } from '@design-system/components/floatingWindow/floatingWindow';
import { Modal } from '@design-system/components/modal/modal';
import { createPortal } from 'react-dom';
import { DropZone } from '@design-system/components/dropZone/dropZone';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import { sprinkles } from '@design-system/sprinkles.css';
import { UpladCta } from './UploadCta';
import { UploadList } from './UploadList';
import { useUploadVideoVM } from '../../view-models/uploadVideo.viewModel';
import { useToastEffect } from '@client/new/helpers/useNotifcations';
import { allowedVideoTypes } from '../../constants';

export const VideoUploadStateModal = () => {
  const {
    dispatch,
    list,
    modal,
    floatingWindow,
    confirmationModal,
    notifications,
  } = useUploadVideoVM();
  useToastEffect(notifications);

  return (
    <>
      {createPortal(
        <>
          <FloatingWindow
            {...floatingWindow}
            toggle={() => dispatch('toggle')}
          />
          <Modal
            isOpen={modal.open}
            onClose={() => dispatch('closeModal')}
            title="Upload Files"
            customCloseIcon={modal.customCloseIcon}
            disableBackdropClick={true}
          >
            <div
              className={sprinkles({
                display: 'flex',
                flexDirection: 'column',
                gap: 'xl',
              })}
            >
              {modal.showDropZone ? (
                <DropZone
                  onChange={(files: File[]) => dispatch('onDrop', files)}
                  accept={allowedVideoTypes}
                  multiple={true}
                  className="h-[170px]"
                />
              ) : null}
              <UploadList {...list} dispatch={dispatch} />
              <UpladCta
                dispatch={dispatch}
                showUpload={modal.uploadButton.show}
                uploadDisabled={modal.uploadButton.disabled}
              />
            </div>
          </Modal>
          <Modal
            isOpen={confirmationModal.open}
            onClose={() => dispatch('closeConfirmation')}
            title="Exit screen?"
            disableBackdropClick={true}
            modalClassName="w-full md:w-[450px]"
          >
            <div className="flex flex-col gap-6">
              <Typography variant="bodyLarge">
                Are you sure you want to exit the upload screen? Any progress
                will be lost.
              </Typography>
              <div className="flex justify-between">
                <Button
                  onClick={() => dispatch('closeConfirmation')}
                  color="neutral"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => dispatch('confirmCancel')}
                  variant="text"
                  color="neutral"
                >
                  Exit
                </Button>
              </div>
            </div>
          </Modal>
        </>,
        document.body,
      )}
    </>
  );
};
